/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class VgTrainingPlan extends Ce {
    constructor() {
        super();
        this.baseUrl += '/vgTrainingPlan';
    }

    getDetail({ verticalGroupingId }) {
        return super.get('/get', { verticalGroupingId });
    }

    initTrainingPlan({ verticalGroupingId, trainingPlanProgramId, trainingPlanProgramTime }) {
        return super.post('/initTrainingPlan', { verticalGroupingId, trainingPlanProgramId, trainingPlanProgramTime });
    }

    saveTrainingPlan({ verticalGroupingId, trainingPlanListJson, remarks, teachingMaterials } = {}) {
        return super.post('/saveTrainingPlan', {
            verticalGroupingId,
            trainingPlanListJson,
            remarks,
            teachingMaterials,
        });
    }
}

export default new VgTrainingPlan();
export { VgTrainingPlan };
